// Robust Mobile Mega Menu toggle — works on iOS/Android and with aggressive theme scripts
(function () {
  function findPanel(btn) {
    // Prefer aria-controls
    const id = btn.getAttribute('aria-controls');
    if (id) {
      const p = document.getElementById(id);
      if (p) return p;
    }
    // Fallback: nextElementSibling for parent items, or matching UL for child buttons
    let sib = btn.nextElementSibling;
    if (sib && (sib.classList.contains('mm-panel') || sib.classList.contains('mm-sub'))) {
      return sib;
    }
    // Last resort: search within the same item
    const wrap = btn.closest('.mm-item, .mm-list__item') || btn.parentElement;
    if (!wrap) return null;
    return wrap.querySelector('.mm-panel, .mm-sub');
  }

  function toggle(btn) {
    const panel = findPanel(btn);
    if (!panel) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  }

  // Use capture so we fire even if other scripts stopPropagation()
  const handler = function (e) {
    const target = e.target;
    if (!target) return;
    const btn = target.closest && target.closest('.js-mm-toggle');
    if (!btn) return;
    if (!btn.closest('.mm-mobile')) return;

    e.preventDefault();
    toggle(btn);

    // Accordion: close open siblings at same level
    const container = (btn.closest('.mm-item, .mm-list__item') || {}).parentElement;
    if (container) {
      const currentId = btn.getAttribute('aria-controls');
      container.querySelectorAll('.js-mm-toggle[aria-expanded="true"]').forEach(other => {
        if (other === btn) return;
        const panel = findPanel(other);
        if (panel) {
          other.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        }
      });
    }
  };

  // Click + touchend (some iOS builds delay click or swallow it)
  document.addEventListener('click', handler, { capture: true, passive: false });
  document.addEventListener('touchend', handler, { capture: true, passive: false });

  // Optional: log presence (helps confirm binding on device without inspector)
  try {
    const count = document.querySelectorAll('.mm-mobile .js-mm-toggle').length;
    console && console.log && console.log('[MM] toggles bound:', count);
  } catch (_) {}
})();

